import { Paper as MuiPaper, Stack, styled } from "@mui/material";
import { PageTitle } from "components";
import { useChannelList } from "hooks";
import { ChannelListTable } from "./components";
import ChannelActions from "./components/ChannelActions";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";

const ChannelManagement = () => {
  const { channels, totalChannels, page, totalPages, isFetching, handleSearchChange, handlePageChange } =
    useChannelList();
  const { t: getLabel } = useTranslation();
  const titleObjectContent = getLabel(LangConstant.OBJ_SIDEBAR_TITLE, { returnObjects: true });

  return (
    <Stack height="100%" bgcolor="#F1F1F1">
      <PageTitle>{titleObjectContent.channelManagement}</PageTitle>

      <Paper>
        <ChannelActions onSearchChange={handleSearchChange} />
        <ChannelListTable
          isFetching={isFetching}
          channels={channels}
          totalChannels={totalChannels}
          page={page}
          totalPages={totalPages}
          onChangePage={handlePageChange}
        />
      </Paper>
    </Stack>
  );
};

export default ChannelManagement;

const Paper = styled(MuiPaper)({
  padding: "20px 16px 16px",
  display: "flex",
  flexDirection: "column",
  gap: 16,
  flex: 1,
});
